import { ExternalLink } from 'lucide-react'

export interface Partner {
  name: string
  logo: string
  href?: string
}

interface PartnerScrollerProps {
  partners: Partner[]
}

export function PartnerScroller({ partners }: PartnerScrollerProps) {
  // Duplicate the list so the scroll loop appears seamless
  const track = [...partners, ...partners]

  return (
    <div className="group relative overflow-hidden py-6 md:py-8">
      <div className="pointer-events-none absolute inset-y-0 left-0 w-16 md:w-24 bg-gradient-to-r from-bg to-transparent z-10" aria-hidden="true" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-16 md:w-24 bg-gradient-to-l from-bg to-transparent z-10" aria-hidden="true" />

      <div
        className="flex w-max animate-partner-scroll motion-reduce:animate-none group-hover:[animation-play-state:paused]"
        aria-label="Partner e fornitori"
      >
        {track.map((partner, index) => {
          const content = (
            <div className="flex h-16 md:h-20 w-40 md:w-48 items-center justify-center px-4">
              <img
                src={partner.logo}
                alt={partner.name}
                className="max-h-full max-w-full object-contain grayscale transition-all duration-300 group-hover/logo:grayscale-0"
                loading="lazy"
              />
            </div>
          )

          return (
            <div
              key={`${partner.name}-${index}`}
              className="group/logo flex-shrink-0 px-3 md:px-5"
            >
              {partner.href ? (
                <a
                  href={partner.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="relative flex items-center justify-center rounded-xl border border-border bg-surface p-3 hover:border-brand hover:shadow-md transition-all"
                  title={`${partner.name} — apri in una nuova scheda`}
                >
                  {content}
                  <span className="absolute top-2 right-2 text-text-muted opacity-0 group-hover/logo:opacity-100 transition-opacity">
                    <ExternalLink className="h-3.5 w-3.5" />
                  </span>
                </a>
              ) : (
                <div className="flex items-center justify-center rounded-xl border border-border bg-surface p-3">
                  {content}
                </div>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}
